export class Group {
    id = '';
    name = '';
    // jid = this.name + '@conference.rtc1';
    roomName = '';
    headPortrait = '';


    static of(o: any) {
        return Object.assign(new Group(), o);

    }
}
